import * as cx from 'classnames';
import { ChangeEvent } from 'react';
import * as React from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import * as Styles from './TextArea.scss';

interface ITextAreaFieldProps {
  id: string;
  value: string;
  name: string;
  placeholder?: string;
  label: string;
  onChange: (event: ChangeEvent<any>) => void;
}

const TextArea = (props: ITextAreaFieldProps) => {
  const { value, name, placeholder, label, onChange } = props;
  const componentClasses = cx({
    [Styles.wrapper]: true,
    [Styles.floatingLabel]: value !== '',
  });

  return (
    <div className={componentClasses}>
      <label className={Styles.label}>{label}</label>
      <TextareaAutosize
        className={Styles.textarea}
        name={name}
        onChange={onChange}
        value={value}
        placeholder={placeholder ? placeholder : ''}
      />
    </div>
  );
};

export default TextArea;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/TextArea/TextArea.tsx